import { useEffect, useState } from 'react';
import Expander from '../../components/expander/Expander';
import { TpSectionsIndexContext } from '../../components/sections-index/SectionsIndex';
import { TpAssetInfo, TpAssetRelationInfo } from '../../data/assets/interfaces';
import AssetNetworkView from '../asset-network-view/AssetNetworkView';
import { currentTheme } from '../themes/themes';
import Dashboard from '../visual-analytics/dashboard/Dashboard';
import MetaData from './elements/MetaData';
import Relations from './elements/Relations';
import { AssetPipelineBuilder } from './elements/AssetPipelineBuilder';

interface TpAssetViewFactoryProps {
  activeAssetInfoId: string;
  assetInfo: TpAssetInfo;
  setAssetInfo: (asset: TpAssetInfo) => void;
  sectionIndexContext: TpSectionsIndexContext;
  assetViewTemplate: any;
  assetOntology: any;
}

export function AssetViewFactory({
  activeAssetInfoId,
  assetInfo,
  setAssetInfo,
  assetViewTemplate,
  sectionIndexContext,
  assetOntology,
}: TpAssetViewFactoryProps) {
  const componentMap: any = {
    propertyList: MetaData,
    relatedAssets: Relations,
    analyticsDashboard: Dashboard,
    assetNetworkView: AssetNetworkView,
  };

  const [relations, setRelations] = useState<TpAssetRelationInfo[]>([]);
  const [assetViewFactoryReady, setAssetViewFactoryReady] = useState(false);

  useEffect(() => {
    setAssetViewFactoryReady(true);
  }, [activeAssetInfoId]);

  return (
    assetViewFactoryReady && (
      <div key={activeAssetInfoId}>
        {assetViewTemplate.assetviewElements.map((element: any, index: string) => {
          const Component = componentMap[element.type];

          if (Component) {
            let comp = (
              <Component
                key={index}
                assetInfo={assetInfo}
                setAssetInfo={setAssetInfo}
                dashboardtemplate={element}
                {...element}
                sectionIndexContext={sectionIndexContext}
                relations={relations}
                setRelations={setRelations}
              />
            );
            if (element.collapsedMaxHeight)
              comp = (
                <Expander
                  key={index}
                  collapsedMaxHeight={element.collapsedMaxHeight}
                  backgroundColor={currentTheme.colors.background2}
                >
                  {comp}
                </Expander>
              );
            return comp;
          }
          return <div key={index}>Invalid Component Key: {element.key}</div>;
        })}
        {assetOntology && assetOntology.isETLPipeline && (
          <AssetPipelineBuilder
            assetInfo={assetInfo}
            setAssetInfo={setAssetInfo}
            sectionIndexContext={sectionIndexContext}
          />
        )}
      </div>
    )
  );
}
